export default function apiConfiguration() {
	let xhrConfiguration =  {
		headers: {
			Accept: 'application/ld+json',
			'Content-Type': 'application/ld+json'
		}
	}

	return xhrConfiguration
}


// WEBPACK FOOTER //
// ./src/utilities/api/apiConfiguration.js